module.exports = __webpack_public_path__ + "static/media/story_18.0a93cc4c.jpg";